import { RESOLUTION_OPTIONS } from '../LiveStreams.constants';

export const getStreamWidth = (resolution, numberOfStreams) => {
  switch (resolution) {
    case RESOLUTION_OPTIONS.AUTO.value:
      if (numberOfStreams < 3) return 'calc(100% - 10px)';
      if (numberOfStreams < 5) return 'calc(50% - 20px)';
      if (numberOfStreams < 10) return 'calc(33% - 30px)';
      return 'calc(25% - 40px)';
    case RESOLUTION_OPTIONS.ONE_IN_ROW.value:
      return 'calc(100% - 10px)';
    case RESOLUTION_OPTIONS.TWO_IN_ROW.value:
      return 'calc(50% - 20px)';
    case RESOLUTION_OPTIONS.THREE_IN_ROW.value:
      return 'calc(33% - 30px)';
    case RESOLUTION_OPTIONS.FOR_IN_ROW.value:
      return 'calc(25% - 40px)';
    default:
      return 'calc(100% - 10px)';
  }
};
